import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';

// Lazy load admin components for better performance
const Login = lazy(() => import('./pages/admin/Login'));
const DashboardLayout = lazy(() => import('./components/admin/DashboardLayout'));
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const PortfolioManager = lazy(() => import('./pages/admin/PortfolioManager'));
const TeamMembers = lazy(() => import('./pages/admin/TeamMembers'));
const JobVacancies = lazy(() => import('./pages/admin/JobVacancies'));
const JobApplications = lazy(() => import('./pages/admin/JobApplications'));
const ContactSubmissions = lazy(() => import('./pages/admin/ContactSubmissions'));
const QuoteRequests = lazy(() => import('./pages/admin/QuoteRequests'));
const WebsiteSettings = lazy(() => import('./pages/admin/WebsiteSettings'));

// Auth guard component to protect admin routes
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/lisa" replace />;
  }
  return children;
};

const AdminRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/lisa" element={<Login />} />
        <Route
          path="/lisa/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="portfolio" element={<PortfolioManager />} />
          <Route path="team" element={<TeamMembers />} />
          <Route path="jobs" element={<JobVacancies />} />
          <Route path="careers" element={<JobApplications />} />
          <Route path="contact" element={<ContactSubmissions />} />
          <Route path="quotes" element={<QuoteRequests />} />
          <Route path="settings" element={<WebsiteSettings />} />
          <Route path="*" element={<Navigate to="/lisa/dashboard" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AdminRoutes;